const styles = theme => ({
  root: {
    
  },

  title: {
    "& h3": {
      marginTop: 5
    }
  },

  project: {
    '& .title': {
      marginTop: 5,
      borderBottom: "1px solid #ccc",
      textTransform: 'uppercase',

      "& h3": {
        fontWeight: "600 !important",
        color: theme.colors.color7
      }
    },

    "& .content": {
      display: "flex",
      flexWrap: "wrap",
      marginLeft: "-15px",
      marginRight: "-15px"
    },
  },

  other: {
    marginTop: 10,
    '& .title': {
      marginTop: 5,
      borderBottom: "1px solid #ccc",
      textTransform: 'uppercase',

      "& h3": {
        fontWeight: "600 !important",
        color: theme.colors.color7
      }
    },

    "& .content": {
      display: "flex",
      flexWrap: "wrap",
      marginLeft: "-5px",
      marginRight: "-5px"
    }
  },

  noContent: {
    marginTop: 10,
    fontWeight: 400,
    color: 'red',
    fontStyle: 'italic',
    fontSize: 18
  }
});

export default styles;